import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';
import { captureException } from '@sentry/react';
import { useIntl } from 'react-intl';
import { SerializedInventoryMeter } from '@enmon/commons/lib/tools';
import { useServices } from '../../../services/useServices';
import { useAppMessages } from '../../useAppMessages';
import { GetInventoryMeterResult } from '../../../services/api/inventoryMeters';
import { QUERY_KEYS } from '../../../utils/queryKeys';
import { InventoryMeter as messages } from '../../messages';

export const useInventoryMeter = (
  id: SerializedInventoryMeter['id'],
  { enabled, staleTime, onSuccess }: UseQueryOptions<GetInventoryMeterResult> = {},
): UseQueryResult<GetInventoryMeterResult> => {
  const intl = useIntl();
  const {
    api: { inventoryMetersApiClient },
  } = useServices();

  const appMessages = useAppMessages();

  return useQuery({
    queryKey: QUERY_KEYS.inventoryMeters.one(id),
    queryFn: async ({ signal }) => await inventoryMetersApiClient.findOne({ id, signal }),
    enabled,
    staleTime,
    onError: error => {
      console.error(error);
      captureException(error);
      appMessages.error(intl.formatMessage(messages.noInventoryMeterFound));
    },
    onSuccess,
  });
};
